<template>
  <v-row no-gutters >
    <v-col cols="12">
      <v-chip-group
        v-model="tab"
        class="px-2"
        active-class="primary--text"
        column
      >
        <v-chip v-for="(tab, index) in tabs" :key="index">
          {{ tab }}
        </v-chip>
      </v-chip-group>
    </v-col>
    <v-col cols="12">
      <v-tabs-items v-model="tab">
        <v-tab-item key="0" transition="fade">
          <moneyline :event="event" />
          <timestamp :event="event" />
        </v-tab-item>
        <v-tab-item key="1" transition="fade">
          <spread :event="event" />
          <timestamp :event="event" />
        </v-tab-item>
        <v-tab-item key="2" transition="fade">
          <over-under :event="event" />
          <timestamp :event="event" />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Moneyline from "./More/Moneyline";
import Spread from "./More/Spread";
import OverUnder from "./More/OverUnder";
import Timestamp from './More/Timestamp';

export default {
  name: "Event",
  data() {
    return {
      tab: null,
    };
  },
  components: {
    Moneyline,
    Spread,
    OverUnder,
    Timestamp,
  },
  props: {
    event: Object,
  },
  computed: {
    tabs() {
      var tabsArray = [];
      
      tabsArray.push("Moneyline");

      tabsArray.push("Spread");

      tabsArray.push("Over Under");

      return tabsArray;
    },
  },
};
</script>

<style scoped>
::v-deep .v-slide-group__content {
    justify-content: center;
}
</style>